import { ChangeEvent } from 'react';
import { useThemeContext } from 'context/ThemeContext/ThemeContext';

type Props = {
  options: string[];
  name: string;
  defaultValue?: string;
  onChange: (value: string, e: ChangeEvent<HTMLInputElement>) => void;
};

const RadioButtons = (props: Props) => {
  const { options, defaultValue, onChange, name } = props;
  const { brandTheme } = useThemeContext();
  const defaultColor = '#414149';
  const checkedColor = brandTheme || defaultColor;
  const radioSize = '20px';

  return (
    <div
      role='radiogroup'
      className='flex flex-col'
      aria-labelledby='radio-buttons-group'
    >
      {options.map((value) => {
        const isSelected = value === defaultValue;
        return (
          <label
            key={value}
            className='w-full flex items-start mx-0 my-1.5 cursor-pointer'
          >
            <div
              style={{
                position: 'relative',
                width: radioSize,
                height: radioSize,
                marginRight: '12px',
              }}
            >
              <input
                type='radio'
                name={name}
                value={value}
                checked={isSelected}
                onChange={(event) => onChange(event.target.value, event)}
                className='cursor-pointer'
                style={{
                  width: '100%',
                  height: '100%',
                  margin: 0,
                  appearance: 'none',
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  border: `2px solid ${
                    isSelected ? checkedColor : defaultColor
                  }`,
                  borderRadius: '50%',
                  backgroundColor: 'transparent',
                  cursor: 'pointer',
                  position: 'relative',
                }}
              />
              {isSelected && (
                <>
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      pointerEvents: 'none',
                      width: '10px',
                      height: '10px',
                      borderRadius: '50%',
                      backgroundColor: 'white',
                    }}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      pointerEvents: 'none',
                      width: '10px',
                      height: '10px',
                      borderRadius: '50%',
                      backgroundColor: checkedColor,
                    }}
                  />
                </>
              )}
            </div>
            <span className='text-sm leading-5 font-semibold pt-0.5'>
              {value}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default RadioButtons;
